import  { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Spinner } from "react-bootstrap";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import axios from "axios";

function CheckpointStatusModal({ show, handleClose }) {
  const [fieldInputs, setFieldInputs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchExistingStatuses();
    }
  }, [show]);

  const fetchExistingStatuses = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/checkpointstatus/?page_size=all`,
        {
          headers: HEADERS,
        }
      );

      if (Array.isArray(response.data.results)) {
        const existingStatuses = response.data.results.map((status) => ({
          id: status.id,
          value: status.status_name,
        }));
        setFieldInputs(existingStatuses);
        setLoading(false)
      } else {
        toast.error("Invalid data format received from the server.");
      }
    } catch (error) {
      
    }
  };

  const handleAddFieldInput = () => {
    const nextFieldNumber =
      fieldInputs.length > 0
        ? Math.max(...fieldInputs.map((f) => f.id)) + 1
        : 1;
    setFieldInputs([...fieldInputs, { id: nextFieldNumber, value: "" }]);
  };

  const handleRemoveFieldInput = (index) => {
    const newInputs = [...fieldInputs];
    newInputs.splice(index, 1);
    setFieldInputs(newInputs);
  };

  const handleFieldInputChange = (value, index) => {
    const newInputs = [...fieldInputs];
    newInputs[index].value = value;
    setFieldInputs(newInputs);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const statuses = fieldInputs.map((field) => ({ status_name: field.value }));

    try {
      await axios.post(
        `${BASE_URL}/api/checkpointstatus/`,
        { statuses },
        {
          headers: HEADERS,
        }
      );
      toast.success("Checkpoint statuses submitted successfully!");
      handleClose();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } 
      } 
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Checkpoint Status</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            {fieldInputs.map((field, index) => (
              <div key={field.id} className="mb-3 d-flex">
                <Form.Control
                  type="text"
                  value={field.value}
                  onChange={(e) =>
                    handleFieldInputChange(e.target.value, index)
                  }
                  placeholder={`Checkpoint Status`}
                  required
                  className="me-2"
                />
                {index > 0 && (
                  <Button
                    variant="danger"
                    onClick={() => handleRemoveFieldInput(index)}
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                )}
              </div>
            ))}
            <Button variant="primary" onClick={handleAddFieldInput}>
              + Add Checkpoint Status
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
              </>
            ) : (
              "submit"
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default CheckpointStatusModal;
